import { DIALER_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'hopperSpeed',
  type: 'dataDog',
}

const formatting = {
  format: {
    title: 'Hopper Speed',
    append: '/ms',
  },
}

const keys = {
  componentKeys: [DIALER_METRICS],
  healthKey: 'performance_health',
}

const hopperSpeed = {
  metaData: Object.assign(identifiers, formatting, keys),
}

export { hopperSpeed }
